<div class="overlay" (click)="cerrar()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="header">
      <h3>Editar usuario</h3>
      <button class="close-btn" (click)="cerrar()">&times;</button>
    </div>

    <div class="body">
      <div class="field">
        <label for="edit-user-name">Nombre</label>
        <input id="edit-user-name" type="text" [(ngModel)]="name" placeholder="Nombre del usuario">
      </div>

      <div class="field">
        <label for="edit-user-role">Rol</label>
        <select id="edit-user-role" [(ngModel)]="roleId" [attr.disabled]="canEditRole ? null : ''">
          <option [ngValue]="1">Admin</option>
          <option [ngValue]="2">User</option>
        </select>
      </div>
    </div>

    <div class="footer">
      <button (click)="cerrar()">Cancelar</button>
      <button class="primary" (click)="guardar()">Guardar</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/edit-user-modal/edit-user-modal.component.html